import api from '../../../utils/api';

export const RATE_LBS_PER_DAY = {
  low: 5,
  avg: 10,
  high: 20,
  very_high: 30,
};

function pathForTarget(target) {
  // target: { kind: 'club'|'personal', id }
  if (!target || !target.kind || !target.id) throw new Error('Invalid target');
  return target.kind === 'club'
    ? `/hunt-locations/${target.id}`
    : `/features/${target.id}`;
}

export async function getFeedingStatus(target) {
  const base = pathForTarget(target);
  const { data } = await api.get(`${base}/feeding_status/`);
  return data || {};
}

export async function listFeedEvents(target, limit = 20) {
  const base = pathForTarget(target);
  const { data } = await api.get(`${base}/feed_events/`);
  return Array.isArray(data) ? data.slice(0, limit) : [];
}

export async function addFeedEvent(target, { amount_lbs, recorded_at, note, feed_type }) {
  const base = pathForTarget(target);
  const payload = { amount_lbs };
  if (recorded_at) payload.recorded_at = recorded_at;
  if (note) payload.note = note;
  if (feed_type) payload.feed_type = feed_type;
  const { data } = await api.post(`${base}/feed_events/`, payload);
  return data;
}

export async function getFeedingOverview() {
  const { data } = await api.get('/feeding/overview/');
  return data || { totals: { low: 0, medium: 0, high: 0, critical: 0 }, next_refills: [], recent_events: [] };
}

export async function getClubFeedingOverview(clubId) {
  if (!clubId) {
    return { totals: { low: 0, medium: 0, high: 0, critical: 0 }, next_refills: [], recent_events: [], season_lbs: 0 };
  }
  const { data } = await api.get(`/clubs/${clubId}/feeding/overview/`);
  return data || { totals: { low: 0, medium: 0, high: 0, critical: 0 }, next_refills: [], recent_events: [], season_lbs: 0 };
}

export async function updateDefaultFeedType(target, feedType) {
  if (!target || !target.kind || !target.id) throw new Error('Invalid target');
  const path = target.kind === 'club'
    ? `/hunt-locations/${target.id}/`
    : `/features/${target.id}/`;
  const payload = { default_feed_type: feedType };
  const { data } = await api.patch(path, payload);
  return data;
}

export async function updateConsumptionRateCode(target, consumptionRateCode) {
  if (!target || !target.kind || !target.id) throw new Error('Invalid target');
  if (!consumptionRateCode) throw new Error('consumption_rate_code is required');
  const path = target.kind === 'club'
    ? `/hunt-locations/${target.id}/`
    : `/features/${target.id}/`;
  const { data } = await api.patch(path, { consumption_rate_code: consumptionRateCode });
  return data;
}

export async function updateFeederActive(target, isActive) {
  if (!target || !target.kind || !target.id) throw new Error('Invalid target');
  const path = target.kind === 'club'
    ? `/hunt-locations/${target.id}/`
    : `/features/${target.id}/`;
  const { data } = await api.patch(path, { feeding_is_active: Boolean(isActive) });
  return data;
}

const feedingApi = {
  RATE_LBS_PER_DAY,
  getFeedingStatus,
  listFeedEvents,
  addFeedEvent,
  getFeedingOverview,
  getClubFeedingOverview,
  updateDefaultFeedType,
  updateConsumptionRateCode,
  updateFeederActive,
};

export default feedingApi;


